const managerListCollaborator = (query) => {
	return `query ListManagerCollaborator {
		listManagerCollaborator {
			${query}
		}
	}`;
}

export default managerListCollaborator;
